import { render, staticRenderFns } from "./JuridicalDocumentationStep.vue?vue&type=template&id=35c5c526&scoped=true&"
import script from "./JuridicalDocumentationStep.vue?vue&type=script&lang=js&"
export * from "./JuridicalDocumentationStep.vue?vue&type=script&lang=js&"
import style0 from "./JuridicalDocumentationStep.vue?vue&type=style&index=0&id=35c5c526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c5c526",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c5c526')) {
      api.createRecord('35c5c526', component.options)
    } else {
      api.reload('35c5c526', component.options)
    }
    module.hot.accept("./JuridicalDocumentationStep.vue?vue&type=template&id=35c5c526&scoped=true&", function () {
      api.rerender('35c5c526', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/portal-cebas/credentialing/steps/JuridicalDocumentationStep.vue"
export default component.exports